module.exports = __webpack_public_path__ + "img/yml_detail.83c36b53.jpg";